export enum EBlockSize {
    SMALL = 'small',
    MIDDLE = 'middle',
    LARGE = 'large',
}

export interface IDataProps {
    id: number,
    blockSize: EBlockSize,
    title?: string,
    desc?: string,
    imgPath?: string,
    webpPath?: string,
    imgAlt?: string,
    mobile?: {
        imgPath: string,
        webpPath: string,
    },
    gifPath?: string,
    media?: {
        [key: string]: string,
    },
}

const imagesPath = '/static/images/service/agent/blocks';

export const pageData: IDataProps[] = [
    {
        id: 1,
        blockSize: EBlockSize.MIDDLE,
        title: 'Заказывайте полезные устройства',
        desc: 'У&nbsp;нас есть умные колонки, Wi-Fi роутеры и&nbsp;многое другое. Просто выберите и&nbsp;закажите, а&nbsp;инженер всё настроит и&nbsp;подключит.',
        imgPath: `${imagesPath}/1_equipment.png`,
        webpPath: `${imagesPath}/1_equipment.webp`,
        imgAlt: 'Изображения Яндекс.Станции и камеры видеонаблюдения',
    },
    {
        id: 2,
        blockSize: EBlockSize.MIDDLE,
        title: 'Держите всё под контролем',
        desc: 'Управляйте заявками, заказами, услугами и&nbsp;тарифом. А&nbsp;мы&nbsp;расскажем, когда лучше пополнить баланс и&nbsp;о&nbsp;технических работах.',
        imgPath: `${imagesPath}/2_info.png`,
        webpPath: `${imagesPath}/2_info.webp`,
        imgAlt: 'Изображения уведомлений мобильного приложения',
    },
    {
        id: 3,
        blockSize: EBlockSize.SMALL,
        title: 'Будьте в&nbsp;курсе',
        desc: 'Хватает&nbsp;ли скорости интернета, всё&nbsp;ли в&nbsp;порядке с&nbsp;интернетом&nbsp;&mdash; вся важная информация теперь в&nbsp;одном месте',
        imgPath: `${imagesPath}/3_notifications.png`,
        webpPath: `${imagesPath}/3_notifications.webp`,
        imgAlt: 'Изображения информационных блоков в приложении',
    },
    {
        id: 4,
        blockSize: EBlockSize.SMALL,
        title: 'Управляйте роутером',
        desc: 'Включайте и&nbsp;отключайте Wi-Fi, выбирайте подходящую частоту и&nbsp;перезагружайте роутер одним кликом',
        media: {
            mp4: `${imagesPath}/4_control.mp4`,
            webm: `${imagesPath}/4_control.webm`,
        },
    },
    {
        id: 5,
        blockSize: EBlockSize.SMALL,
        imgPath: `${imagesPath}/5_girl.jpg`,
        webpPath: `${imagesPath}/5_girl.webp`,
        imgAlt: 'Девушка смотрит в телефон, сидя за ноутбуком',
        mobile: {
            imgPath: `${imagesPath}/5_girl_mobile.jpg`,
            webpPath: `${imagesPath}/5_girl_mobile.webp`,
        },
    },
    {
        id: 6,
        blockSize: EBlockSize.SMALL,
        title: 'Получайте персональные предложения',
        desc: 'Все бонусы, новые тарифы и&nbsp;предложения от&nbsp;партнёров собраны в&nbsp;одном месте.',
        imgPath: `${imagesPath}/6_economy.png`,
        webpPath: `${imagesPath}/6_economy.webp`,
        imgAlt: 'Изображения акций и карты программы лояльности',
    },
    {
        id: 7,
        blockSize: EBlockSize.LARGE,
        title: 'Общайтесь с&nbsp;поддержкой в&nbsp;чате',
        desc: 'Не&nbsp;надо звонить и&nbsp;ждать ответа. Напишите в&nbsp;чат и&nbsp;спокойно занимайтесь своими делами. ' +
            'Пришлём уведомление, когда оператор найдёт ответ на&nbsp;ваш вопрос.',
        imgPath: `${imagesPath}/7_chat.png`,
        webpPath: `${imagesPath}/7_chat.webp`,
        imgAlt: 'Изображение диалога в чате',
        gifPath: `${imagesPath}/7_chat.gif`,
    },
];
